export { default as Img200 } from './processed/200/EndOfEmpire_Key-Art.jpg';
export { default as Img400 } from './processed/400/EndOfEmpire_Key-Art.jpg';
export { default as Imgthumb } from './processed/thumb/EndOfEmpire_Key-Art.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/EndOfEmpire_Key-Art.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/EndOfEmpire_Key-Art.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      156,
      108,
      44
    ],
    "_population": 1,
    "_hsl": [
      0.09523809523809523,
      0.5599999999999999,
      0.3921568627450981
    ]
  },
  "LightVibrant": {
    "_rgb": [
      234,
      214,
      172
    ],
    "_population": 7,
    "_hsl": [
      0.11290322580645162,
      0.5961538461538458,
      0.7960784313725491
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      79,
      52,
      20
    ],
    "_population": 54,
    "_hsl": [
      0.0903954802259887,
      0.595959595959596,
      0.19411764705882353
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      130,
      94
    ],
    "_population": 53,
    "_hsl": [
      0.09523809523809519,
      0.250996015936255,
      0.49215686274509807
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      185,
      153
    ],
    "_population": 6,
    "_hsl": [
      0.10256410256410253,
      0.34210526315789486,
      0.7019607843137254
    ]
  },
  "DarkMuted": {
    "_rgb": [
      105,
      84,
      52
    ],
    "_population": 6,
    "_hsl": [
      0.10062893081761008,
      0.3375796178343949,
      0.307843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/EndOfEmpire_Key-Art.js